import { commonClassName, commonHeaderClass } from 'components/pages/PromoScorecard';
import React, { FC, useContext } from 'react';
import { subHeaderClass, yAxisLabelClass } from '../GrowthAnalysis/ExpandedView';
import Linechart from 'components/molecules/Linechart';
import { calculateContainerHeight, formatNumWithKMBAlt, getConfig } from 'utils/helperMethods';
import { colorConstants } from 'config/colorConstants';
import { currentYearSalesLineChartData } from 'utils/testData';
import Legend from 'components/molecules/Legend';
import { yAxisWidth } from '../PriceLadder/BarPointChartContainer';
import ErrorBox from 'components/molecules/ErrorBox/ErrorBox';
import Loader from 'components/molecules/Loader';
import { UserContext } from 'contexts/ConfigContext';
import { ConfigKeys } from 'utils/Enums';

interface Props {
    xAxisSelectedValue: any;
    yAxisSelectedValue: any;
    levelsSelectedValue: any;
    selectedLegends: any[];
    data: any;
    loading: boolean;
    error: any;
    selectedBarItem: any;
    widthConfig: {
        containerWidth: number;
    };
}
const chartHeight = calculateContainerHeight(3, 300);

export const trendsChartLegends = [
    { label: 'Year Ago', color: colorConstants.lightBlue },
    { label: 'Current Year', color: colorConstants.pink },
];

const PriceCurveTrendsChartContainer: FC<Props> = ({
    levelsSelectedValue,
    selectedLegends,
    xAxisSelectedValue,
    yAxisSelectedValue,
    data,
    error,
    loading,
    widthConfig,
    selectedBarItem,
}) => {
    //width config
    const { containerWidth } = widthConfig;
    const { appConfig } = useContext(UserContext);
    const { decimalForNonPercentage, decimalForPercentage } = getConfig(ConfigKeys.COMMON_CONFIG, appConfig);

    const mainLabel =
        selectedLegends?.length === 1
            ? `Trend Chart for ${yAxisSelectedValue?.label} Incentive for ${levelsSelectedValue?.label} - ${selectedBarItem?.[0]?.category} `
            : `Trend Chart for ${yAxisSelectedValue?.label} Incentive by ${xAxisSelectedValue?.label} `;
    return (
        <section className={`${commonClassName} mt-4`}>
            <h2 className={`${subHeaderClass} mb-4  `}>{mainLabel}</h2>
            {loading ? (
                <div style={{ height: chartHeight + 50 }}>
                    <Loader />
                </div>
            ) : error ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: chartHeight + 50,
                    }}
                >
                    <ErrorBox msg={String(error)} />
                </div>
            ) : (
                <>
                    <Legend data={trendsChartLegends} />
                    <p className={`${yAxisLabelClass} mb-4`}>Index</p>
                    <div className="ml-1 flex">
                        <Linechart
                            padding={[0, 0, 12, 0]}
                            // yAxisConfig={false}
                            xAxisConfig={false}
                            YGrid={false}
                            dataset={[]}
                            height={chartHeight}
                            loading={false}
                            chartContainer={`price-curve-trends-chart-y`}
                            fields={['period', 'Year Ago', 'Current Year']}
                            minBound={data?.chartData?.minVal}
                            maxBound={data?.chartData?.maxVal}
                            width={yAxisWidth} //subtracting the padding
                            xAxisLabelFormatter={(val: any) => {
                                return val;
                            }}
                            yAxisLabelFormatter={(val: any) => {
                                return formatNumWithKMBAlt(val, decimalForNonPercentage, decimalForNonPercentage);
                            }}
                            groupedChartColor={[colorConstants.lightBlue, colorConstants.pink]}
                            colorKey={'color'}
                            disableIntervalLabel
                        />
                        <Linechart
                            // yAxisConfig={false}
                            dataset={data?.chartData?.data || []}
                            height={chartHeight}
                            loading={false}
                            chartContainer={`price-curve-trends-chart-main`}
                            fields={['period', 'Year Ago', 'Current Year']}
                            minBound={data?.chartData?.minVal}
                            maxBound={data?.chartData?.maxVal}
                            width={containerWidth || window.innerWidth} //subtracting the padding
                            xAxisLabelFormatter={(val: any) => {
                                return val;
                            }}
                            groupedChartColor={[colorConstants.lightBlue, colorConstants.pink]}
                            colorKey={'color'}
                            disableIntervalLabel
                            tooltipFormatter={(xAxis, val, from) => {
                                return {
                                    name: from,
                                    value: formatNumWithKMBAlt(val, decimalForNonPercentage, decimalForNonPercentage),
                                };
                            }}
                        />
                    </div>
                    <p className={`${yAxisLabelClass} text-center`}>Time</p>
                </>
            )}
        </section>
    );
};

export default PriceCurveTrendsChartContainer;
